/* tslint:disable */
/* eslint-disable */
/**
 * Admin Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

/**
 * 
 * @export
 * @interface OrcidScopeDTO
 */
export interface OrcidScopeDTO  {
    /**
     * 
     * @type {number}
     * @memberof OrcidScopeDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof OrcidScopeDTO
     */
    scope?: string;
}

/**
 * Check if a given object implements the OrcidScopeDTO interface.
 */
export function instanceOfOrcidScopeDTO(value: object): value is OrcidScopeDTO {
    return true;
}

export function OrcidScopeDTOFromJSON(json: any): OrcidScopeDTO {
    return OrcidScopeDTOFromJSONTyped(json, false);
}

export function OrcidScopeDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrcidScopeDTO {
    if (json == null) {
        return json;
    }
    return {
        
                  'id': json['id'] == null ? undefined : json['id'],
                  'scope': json['scope'] == null ? undefined : json['scope'],
    };
}

export function OrcidScopeDTOToJSON(json: any): OrcidScopeDTO {
    return OrcidScopeDTOToJSONTyped(json, false);
}

export function OrcidScopeDTOToJSONTyped(value?: OrcidScopeDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'scope': value['scope'],
    };
}


